export const TRANSLATIONS_HI = {
    'welcome':"मुखपृष्ठ में स्वागत है",
    'login':"लॉग इन करें",
    'temple':"मंदिर बुकिंग",
    'change':"विषय को परिवर्तित करें",
    'read':"सबसे ज्यादा देखे जाने वाले मंदिर",
    'email':"ईमेल पता",
    'pass':"पासवर्ड",
    'p_email':"अपना ईमेल दर्ज करें",
    'p_pass':"अपना पासवर्ड डालें",
    'submit':"प्रस्तुत करना",
    'Viewbooking':"व्यूबुकिंग"
   };